/* eslint-disable import/no-unresolved */
/* eslint-disable jsx-a11y/label-has-associated-control */
/* eslint-disable jsx-a11y/control-has-associated-label */
import {
    AccordionItem, AccordionItemBody, AccordionItemHeader, Accordions, Breadcrumb, Button, Input, Select, SelectOption,
} from 'appkit-react';
import { Col, Row, Alert } from 'react-bootstrap';

import '../styles/createTenant.scss';

const CreateTenant = ({
    history, breadcrumbItems, checkValidation, onSave,
    loading, isOnBoardLoading, showSuccssAlert, setShowSuccssAlert, showErrorAlert,
    setShowErrorAlert, adminErrorMsg, tenantName, setTenantName, tenantNameError,
    setTenantType, tenantType, tenantTypeError, onboardOrganizationAdmin,
    setOnboardOrganizationAdmin, adminEmailError, allowedDomains, setAllowedDomains,
    firstName, setFirstName, firstNameError, lastName, setLastName, lastNameError,
    createUserLoading, setFirstNameError, setLastNameError, setTenantNameError, setTenantTypeError, validateEmail,
}) => (
    <div>
        <div className="true-comply-tenant_management_layout">
            <div className="true-comply-tenant_management_column-2">
                <Breadcrumb items={breadcrumbItems} />

                <Row>
                    <Col md={5}>
                        <div className="a-h2 title-label">
                            <span className="appkiticon icon-left-chevron-outline left-arrow-icon" onClick={() => history.goBack()} role="presentation" />
                            Create Tenant
                        </div>
                    </Col>
                    <Col style={{ textAlign: 'right' }}>
                        <Button
                            className="a-btn a-btn-primary a-btn-lg "
                            kind="primary"
                            size="lg"
                            style={{ marginLeft: '2rem' }}
                            onClick={
                                () => {
                                    checkValidation();
                                    onSave();
                                }
                            }
                            isLoading={loading || isOnBoardLoading || createUserLoading}
                        >
                            Save
                        </Button>
                        <Button className="a-btn a-btn-secondary a-btn-lg " kind="secondary" size="lg" style={{ marginLeft: '1rem' }} onClick={() => history.goBack()}>
                            Cancel
                        </Button>
                    </Col>
                </Row>
                {showSuccssAlert && (
                    <Alert
                        variant="success"
                        onClose={
                            () => {
                                setShowSuccssAlert(false);
                                history.goBack();
                            }
                        }
                        dismissible
                    >
                        New tenant created !
                    </Alert>
                )}

                {showErrorAlert && (
                    <Alert variant="danger" onClose={() => setShowErrorAlert(false)} dismissible="true">{adminErrorMsg}</Alert>
                )}
                <Accordions className="true-comply-create-tenant-accordion" activeItem={['panel-1', 'panel-2']}>
                    <AccordionItem itemId="panel-1" size="lg">
                        <AccordionItemHeader className="background-white header" title="TENANT DETAILS" />
                        <AccordionItemBody className="background-white" size="lg">
                            <hr style={{ marginTop: 0 }} />
                            <Row style={{ paddingBottom: '2rem' }}>
                                <Col md={6}>
                                    <label className="form-label">
                                        TENANT NAME
                                        <span className="required-field">*</span>
                                    </label>
                                    <Input
                                        type="text"
                                        name="tenantName"
                                        value={tenantName}
                                        onChange={e => {
                                            setTenantNameError(false);
                                            setTenantName(e);
                                        }}
                                        hasError={tenantNameError}
                                        errMsg="TENANT NAME is required."
                                    />
                                    <label className="form-label">
                                        ORGANIZATION ADMIN FIRST NAME
                                        <span className="required-field">*</span>
                                    </label>
                                    <Input
                                        type="text"
                                        name="firstName"
                                        value={firstName}
                                        onChange={
                                            e => {
                                                setFirstNameError(false);
                                                setFirstName(e);
                                            }
                                        }
                                        hasError={firstNameError}
                                        errMsg="FIRST NAME is required."
                                    />
                                    <label className="form-label">
                                        TENANT TYPE
                                        <span className="required-field">*</span>
                                    </label>
                                    <Select
                                        placeholder="Select"
                                        onSelect={e => {
                                            setTenantTypeError(false);
                                            setTenantType(e);
                                        }}
                                        value={tenantType}
                                        name="tenantType"
                                        dropdownRenderMode="portal"
                                        style={{ boxShadow: tenantTypeError ? '0 0 0 0.125rem #c52a1a' : '', borderRadius: tenantTypeError ? '2px' : '' }}
                                    >
                                        <SelectOption key={1} value="INTERNAL">
                                            Internal
                                        </SelectOption>
                                        <SelectOption key={2} value="EXTERNAL">
                                            External
                                        </SelectOption>
                                    </Select>
                                    {tenantTypeError && <div style={{ color: '#c52a1a', fontSize: '0.75rem', margin: '.625rem 0 0' }}>TENANT TYPE is required.</div>}
                                </Col>
                                <Col md={6}>
                                    <label className="form-label">
                                        ONBOARD ORGANIZATION ADMIN EMAIL
                                        <span className="required-field">*</span>
                                    </label>
                                    <Input
                                        type="text"
                                        name="onboardOrganizationAdmin"
                                        value={onboardOrganizationAdmin}
                                        onChange={e => {
                                            setOnboardOrganizationAdmin(e);
                                            validateEmail(e);
                                        }}
                                        hasError={adminEmailError}
                                        errMsg="Invalid ONBOARD ORGANIZATION ADMIN EMAIL."
                                    />
                                    <label className="form-label">
                                        ORGANIZATION ADMIN LAST NAME
                                        <span className="required-field">*</span>
                                    </label>
                                    <Input
                                        type="text"
                                        name="lastName"
                                        value={lastName}
                                        onChange={
                                            e => {
                                                setLastNameError(false);
                                                setLastName(e);
                                            }
                                        }
                                        hasError={lastNameError}
                                        errMsg="LAST NAME is required."
                                    />
                                    {/* <label className="form-label">
                                        ALLOWED DOMAINS
                                    </label>
                                    <Input
                                        type="text"
                                        name="allowedDomains"
                                        value={allowedDomains}
                                        onChange={e => { setAllowedDomains(e); }}
                                    /> */}
                                </Col>
                            </Row>
                        </AccordionItemBody>
                    </AccordionItem>
                </Accordions>

            </div>
        </div>
    </div>
);

export default CreateTenant;
